import { render, staticRenderFns } from "./XyMultiSelect.vue?vue&type=template&id=8f54b37a&scoped=true&"
import script from "./XyMultiSelect.vue?vue&type=script&lang=js&"
export * from "./XyMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./XyMultiSelect.vue?vue&type=style&index=0&id=8f54b37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f54b37a",
  null
  
)

export default component.exports